import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import MonteurFields from "@/components/MonteurFields";
import BedrijfAanbodFields from "@/components/BedrijfAanbodFields";
import { PROVINCIES, OP_ZOEK_NAAR } from "@/lib/jobOptions";

export const RegisterExtraFields = ({ role, form, set, setForm }) => (
  <>
    <div className="grid grid-cols-2 gap-3">
      <div>
        <Label className="text-xs font-bold text-slate-700">Telefoon</Label>
        <Input data-testid="telefoon-input" value={form.telefoon} onChange={set("telefoon")}
          className="rounded-sm border-slate-300" placeholder="06..." />
      </div>
      <div>
        <Label className="text-xs font-bold text-slate-700">Regio</Label>
        <Input data-testid="regio-input" value={form.regio} onChange={set("regio")}
          className="rounded-sm border-slate-300" placeholder="bv. Utrecht" />
      </div>
    </div>
    <div>
      <Label className="text-xs font-bold text-slate-700">Provincie van de werf (verplicht)</Label>
      <Select value={form.provincie} onValueChange={set("provincie")}>
        <SelectTrigger data-testid="provincie-select" className="rounded-sm border-slate-300">
          <SelectValue placeholder="Kies een provincie" />
        </SelectTrigger>
        <SelectContent>
          {PROVINCIES.map((g) => (
            <div key={g.groep}>
              <div className="px-2 py-1.5 text-xs font-bold text-slate-400 uppercase tracking-wide">{g.groep}</div>
              {g.opties.map((p) => (
                <SelectItem key={p} value={p}>{p}</SelectItem>
              ))}
            </div>
          ))}
        </SelectContent>
      </Select>
    </div>
    {role === "particulier" && (
      <div data-testid="op-zoek-naar-block">
        <Label className="text-xs font-bold text-slate-700 mb-2 block">Ik ben op zoek naar (meerdere mogelijk)</Label>
        <div className="space-y-2 border border-slate-200 rounded-sm p-3">
          {OP_ZOEK_NAAR.map((opt) => (
            <label key={opt} className="flex items-start gap-2.5 cursor-pointer text-sm text-slate-700">
              <input type="checkbox" data-testid={`op-zoek-${opt}`}
                checked={(form.op_zoek_naar || []).includes(opt)}
                onChange={() => setForm((f) => ({
                  ...f,
                  op_zoek_naar: (f.op_zoek_naar || []).includes(opt)
                    ? f.op_zoek_naar.filter((x) => x !== opt)
                    : [...(f.op_zoek_naar || []), opt],
                }))}
                className="mt-0.5 w-4 h-4 accent-orange-500 flex-shrink-0" />
              <span>{opt}</span>
            </label>
          ))}
        </div>
      </div>
    )}
    {role === "monteur" && (
      <>
        <div>
          <Label className="text-xs font-bold text-slate-700">Specialisatie</Label>
          <Select value={form.specialisatie} onValueChange={set("specialisatie")}>
            <SelectTrigger data-testid="specialisatie-select" className="rounded-sm border-slate-300">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="ramen">Ramen</SelectItem>
              <SelectItem value="deuren">Deuren</SelectItem>
              <SelectItem value="beide">Ramen & Deuren</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label className="text-xs font-bold text-slate-700">Ervaring (jaren)</Label>
            <Input data-testid="ervaring-input" type="number" min="0" value={form.ervaring_jaren} onChange={set("ervaring_jaren")}
              className="rounded-sm border-slate-300" placeholder="5" />
          </div>
          <div>
            <Label className="text-xs font-bold text-slate-700">Uurtarief (€)</Label>
            <Input data-testid="uurtarief-input" type="number" min="0" value={form.uurtarief} onChange={set("uurtarief")}
              className="rounded-sm border-slate-300" placeholder="45" />
          </div>
        </div>
        <MonteurFields data={form} onChange={setForm} />
      </>
    )}
    {role === "bedrijf" && (
      <BedrijfAanbodFields data={form} onChange={setForm} />
    )}
    {role === "bedrijf" && (
      <label className="flex items-start gap-2.5 cursor-pointer bg-slate-50 border border-slate-200 rounded-md px-4 py-3" data-testid="plaatst-voor-collega-wrap">
        <input type="checkbox" data-testid="plaatst-voor-collega-checkbox"
          checked={!!form.plaatst_voor_collega}
          onChange={(e) => setForm({ ...form, plaatst_voor_collega: e.target.checked })}
          className="mt-0.5 w-4 h-4 accent-orange-500 flex-shrink-0" />
        <span className="text-sm text-slate-700">
          <strong>Ik plaats ook voor collega's</strong> — vink dit aan als je zelf ook als professional op geplaatste opdrachten wil kunnen reageren.
        </span>
      </label>
    )}
  </>
);
